import { Bar, CustomLogo, CustomLogoWrapper, MenuWrapper, WrapperContent } from "@components/NavBar/styles";
import { NavbarThemeStyle } from "@interfaces";
import { SvgSendsparkLogo } from '@assets/SvgSendsparkLogo';
import RenderIf from '@components/RenderIf';
import { SVGFacebook2 } from "@assets/SVGFacebook2";
import { useMediaQuery, useTheme } from "@mui/material";
import { SVGInstagram } from "@assets/SVGInstagram";
import { SVGXIcon } from "@assets/SVGXIcon";
import { SVGLinkedin } from "@assets/SVGLinkedin";
import { StyledButton, StyledNavButton } from "./styles";
import { Link } from "@material-ui/core";

interface NavBarProps {
  url?: string;
  size?: number;
  background?: string;
  border?: {
    color?: string;
  };
  navbarThemeStyle?: NavbarThemeStyle & {
    cta?: {
      background?: string;
      color?: string;
      text?: string;
      url?: string;
    }
  };
}

const APMNavbar: React.FC<NavBarProps> = ({
  url,
  background,
  border,
  navbarThemeStyle,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleGoToWebsite = (socialMedia: 'instagram' | 'x' | 'linkedin' | 'facebook') => {
    const socialUrlMap = {
      facebook: 'https://www.facebook.com/americanpacificmortgage',
      instagram: 'https://www.instagram.com/ap_mortgage/',
      x: 'https://x.com/AP_Mortgage',
      linkedin: 'https://www.linkedin.com/company/american-pacific-mortgage',
    }

    window.open(socialUrlMap[socialMedia], "_blank", "noopener noreferrer");
  }

  return (
    <Bar
      backgroundColor={navbarThemeStyle?.background || background}
      border={border}
      padding={navbarThemeStyle?.padding}
      height={navbarThemeStyle?.height}
    >
      <WrapperContent>
        <RenderIf condition={!!url}>
          <CustomLogoWrapper>
            <Link href="https://www.apmortgage.com" target="_blank" rel="noopener noreferrer">
              <CustomLogo src={url} alt="APM Logo" />
            </Link>
          </CustomLogoWrapper>
        </RenderIf>
        <RenderIf condition={!url}>
          <SvgSendsparkLogo />
        </RenderIf>

        <MenuWrapper>
          <RenderIf condition={!isMobile}>
            <StyledButton
              href="https://www.apmortgage.com/join/home"
              target="_blank"
              rel="noopener noreferrer"
            >
              JOIN&nbsp;
              <span>
                APM
              </span>
            </StyledButton>
          </RenderIf>
          <StyledNavButton onClick={() => handleGoToWebsite('facebook')}>
            <SVGFacebook2 width={isMobile ? '24' : '32'} color={navbarThemeStyle?.iconColor} />
          </StyledNavButton>
          
          <StyledNavButton onClick={() => handleGoToWebsite('instagram')}>
            <SVGInstagram width={isMobile ? '24' : '32'} color={navbarThemeStyle?.iconColor} />
          </StyledNavButton>
          
          <StyledNavButton onClick={() => handleGoToWebsite('x')}>
            <SVGXIcon width={isMobile ? '24' : '32'} color={navbarThemeStyle?.iconColor} />
          </StyledNavButton>
          
          <StyledNavButton onClick={() => handleGoToWebsite('linkedin')}>
            <SVGLinkedin width={isMobile ? '24' : '32'} color={navbarThemeStyle?.iconColor} />
          </StyledNavButton>

          <RenderIf condition={isMobile}>
            <StyledButton
              href="https://www.apmortgage.com/join/home"
              target="_blank"
              rel="noopener noreferrer"
              isMobile
            >
              Join
            </StyledButton>
          </RenderIf>
        </MenuWrapper>
      </WrapperContent>
    </Bar>
  )
}

export default APMNavbar